import axios from "../config/Axios";

export const switchToOld = () => {
    axios.post('config/frontend', {'version': 'old'}).then(() => {window.location = '/';});
}
